import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';

export interface NotificationSettingsMenuItemProps {
    className?: string;
    marginLeft?: number;
}

export const NotificationSettingsMenuItem = (
    props: NotificationSettingsMenuItemProps
) => (
    <LeftMenuItem
        icon="pe-7s-bell"
        label="Notification Settings"
        to="/notifications"
        className={props.className ?? 'vertical-nav-menu'}
        marginLeft={props.marginLeft ?? -15}
        trackingAction="Notifications"
    />
);
